import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataFetched: false,
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "mobileFrame",
  initialState: initialState,
  reducers: {
    getMobileFrameData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.dataFetched = false;
    },
    getMobileFrameDataSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.dataFetched = true;
    },
    getMobileFrameDataError: (state, action) => {
      state.error = action.payload;
      state.dataFetched = false;
      state.loading = false;
    },
    mobileFrameResetState: () => initialState,
  },
});

export const {
  getMobileFrameData,
  getMobileFrameDataSuccess,
  getMobileFrameDataError,
  mobileFrameResetState,
} = slice.actions;

export default slice.reducer;
